export default __webpack_public_path__ + "static/media/on-fire.e94eb783.gif";